import React from 'react';
import {useModalControls} from './common';
import {useActions} from './redux';
import {useIVStore} from 'store/identityVerification';
import {useStepperStore} from 'store/stepper';

function useDiscardIVModal() {
  const {resetAllIVState} = useIVStore();
  const {resetPhotoBoxUploadedImage} = useActions();
  const {resetIVProcess} = useStepperStore();

  const {
    isOpen: isOpenDiscardIVModal,
    closeModal: closeDiscardIVModal,
    openModal: openDiscardIVModal,
  } = useModalControls();

  const resetAllIVStates = React.useCallback(() => {
    resetPhotoBoxUploadedImage();
    resetIVProcess();
    resetAllIVState();
    closeDiscardIVModal();
  }, [resetPhotoBoxUploadedImage, resetIVProcess, resetAllIVState, closeDiscardIVModal]);

  return {
    isOpenDiscardIVModal,
    closeDiscardIVModal,
    openDiscardIVModal,
    resetIVProcess: resetAllIVStates,
  };
}

export {useDiscardIVModal};
